/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementListEditItemResponse } from './CarpsaleManagementListEditItemResponse';

export type CarpsaleManagementListEditItemResponseApiRespoonse = {
    data?: CarpsaleManagementListEditItemResponse;
    status?: CarpsaleManagementListEditItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementListEditItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

